import BaseCgi from './baseCgi';

/**
 * 可以用来定义除mobile_save_goods，mobile_goods_info之外的没特殊请求串构造逻辑的cgi
 */
export default class extends BaseCgi {
	/**
	 *	opt.domainq 是否是q.unipay.qq.com。 (Warning: cgiUriParam.domain与该参数有冲突，若都传了，cgiUriParam.domain的优先级高)
	 */
  constructor(opt = {}) {
    super(opt);
    this.domainq = opt.domainq !== undefined ? opt.domainq : false;
  }

	/**
	 * 获取cgi的前半部分
	 */
  getUri(cgiObj) {
    let domain;
    if (cgiObj.sandbox) {
      domain = (cgiObj.sandbox === 3 ? 'testing' : cgiObj.sandbox === 2 ? 'dev' : 'sandbox') + '.api.unipay.qq.com'
    } else if (cgiObj.experience) {
      domain = 'tiyan.api.unipay.qq.com'
    } else {
      domain = this.domainq ? 'q.unipay.qq.com' : 'api.unipay.qq.com'
    }

    return ['https://', domain, '/v1/r/', cgiObj.appid, '/', this.cgiName()].join("");
  }
}
